import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);

    // Load user data from localStorage on mount
    useEffect(() => {
        const storedUser = localStorage.getItem("userData");
        if (storedUser) {
            setUserData(JSON.parse(storedUser));
        }
    }, []);

    const setUser = (data) => {
        const safeData = JSON.parse(
            JSON.stringify(data, (_, value) =>
                typeof value === "bigint" ? value.toString() : value
            )
        );
        setUserData(safeData);
        localStorage.setItem("userData", JSON.stringify(safeData));
    };


    const logout = () => {
        setUserData(null);
        localStorage.removeItem("userData");
    };

    return (
        <UserContext.Provider value={{ userData, setUser, logout }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
